// Module
var code = "<div id=\"V-D43CC084-7DD2-4A5B-B218-DCCFA1A7F548\"> <div data-b-component=\"grid\" data-b-comp-columnDefinition=\"auto 1fr\"> <h6 data-b-attach-column=\"1\" class=\"required\">صندوق : </h6> <div data-b-attach-column=\"2\" data-b-component=\"content\" data-b-comp-content=\"{Binding district}\"></div> </div> </div> ";
// Exports
export default code;